/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResourceService } from '@well/resource-services';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { ActionDefinitionDtoMetaDataModel, ActionDefinitionDtoModel } from '@well/domain';

@Injectable({
  providedIn: 'root'
})
export class ActionAddPageService {

  constructor(private actionResourceService: ActionResourceService) { }

  getTemplate(subscriptionTypeUuid: string): Observable<JsonApiResource<ActionDefinitionDtoModel, ActionDefinitionDtoMetaDataModel>> {
    return this.actionResourceService.getTemplateFromSubscriptionUuid(subscriptionTypeUuid);
  }

  save(action: any): Observable<any> {
    return this.actionResourceService.save(action);
  }
}
